import { EXCHANGE_NAME } from "../../../constants/constants";
import { API } from "../../../services/apiService";
const channelToSubscription = new Map();
const lastBarsCache = new Map();
const EXCHANGE_NAME_STRING = 'OasisProMarket';

const config = {
  supports_time: false,
  supported_resolutions: [
    "1",
    "5",
    "15",
    "30",
    "60",
    "120",
    "180",
    "240",
    "720",
    "1d",
    "1w",
    "1m",
  ],
};

// const getResolutionInMinute = (resolution) => {
//   if (resolution === "1D") {
//     return 24 * 60;
//   } else if (resolution === "1W") {
//     return 60 * 24 * 7;
//   } else if (resolution === "1M") {
//     return 60 * 24 * 30;
//   }
//   return resolution;
// };

export const dataFeedObject = (
  pricescaleValue,
  price_decimal,
  base_decimal,
  selectedPairKey
) => {
  const dataFeed = {
    onReady: (callback) => {
      setTimeout(() => callback(config));
    },

    resolveSymbol: (
      symbolName,
      onSymbolResolvedCallback,
      onResolveErrorCallback
    ) => {
      if (!selectedPairKey) {
        onResolveErrorCallback("cannot resolve symbol");
        return;
      }
      const selectedPairName = selectedPairKey.pair;
      // ?.replace("_", "/")
      // ?.toUpperCase();

      const symbolInfo = {
        name: selectedPairName,
        description: selectedPairName,
        type: "crypto",
        session: "24x7",
        timezone: "Etc/UTC",
        exchange: EXCHANGE_NAME,
        ticker: selectedPairName,
        minmov: 1,
        pricescale: pricescaleValue,
        has_intraday: true,
        intraday_multipliers: ["1", "60"],
        // intraday_multipliers: config.supported_resolutions,
        supported_resolutions: config.supported_resolutions,
        has_weekly_and_monthly: true,
        volume_precision: price_decimal ?? 4,
        data_status: "streaming",
      };

      onSymbolResolvedCallback(symbolInfo);
    },

    getBars: async (
      symbolInfo,
      resolution,
      from,
      to,
      onHistoryCallback,
      onErrorCallback,
      firstDataRequest
    ) => {
      // let split_data = symbolInfo.name;
      // split_data = split_data.replace(/_/g, "")
      // split_data = split_data.replace("/", "_")
      if (resolution.toUpperCase() == 'D' || resolution.toUpperCase() == '1D') resolution = '1D';
      if (resolution.toUpperCase() == 'W' || resolution.toUpperCase() == '1W') resolution = '1W';
      if (resolution.toUpperCase() == 'M' || resolution.toUpperCase() == '1M') resolution = '1M';
      const paramsData = {
        interval: resolution,
        pairName: selectedPairKey.pair_key, //split_data.toLowerCase(),//(split_data[0] + "_" + split_data[1])?.toLowerCase(),
        fromDate: from,
        toDate: to,
        limit: 2121,
      };
      return API.fetchGraphData(paramsData)
        .then(({ data }) => {
          if (!data || data === "Error") {
            onHistoryCallback([], { noData: true });
          }

          if (data) {
            const newData = data;
            const bars = [];
            for (let i = 0; i < newData?.t?.length; i++) {
              bars.push({
                time: newData.t[i] * 1000,
                low: newData.l[i],
                high: newData.h[i],
                open: newData.o[i],
                close: newData.c[i],
                volume: newData.v[i],
              });
            }
            if (firstDataRequest) {
              lastBarsCache.set(symbolInfo.name, { ...bars[bars.length - 1] });
            }

            if (bars?.length < 1) {
              onHistoryCallback([], { noData: true });
            } else {
              onHistoryCallback(bars, { noData: false });
            }
          }
        })
        .catch((err) => {
          onHistoryCallback([], { noData: true });
        });
    },

    subscribeBars: (
      symbolInfo,
      resolution,
      onRealtimeCallback,
      subscribeUID,
      onResetCacheNeededCallback
    ) => {
      dataFeed.onRealtimeCallback = (kline) => {
        const newKlineData = {
          selectedPair: selectedPairKey.pair_key,
          price: kline?.price,
          volume: kline?.volume,
          time: getNextBarTime(resolution, kline?.time),
        };
        subscribeBars(
          symbolInfo,
          resolution,
          onRealtimeCallback,
          subscribeUID,
          onResetCacheNeededCallback,
          lastBarsCache.get(symbolInfo.name),
          newKlineData
        );
      };
    },

    unsubscribeBars: (subscribeUID) => {
      unsubscribeBars(subscribeUID);
    },

    onRealtimeCallback: (kline) => { },
  };

  return dataFeed;
};

const createChannelString = (symbolInfo) => {
  var channel = symbolInfo?.split(/[:_/]/);
  const to = channel[1];
  const from = channel[0];
  return `0~${EXCHANGE_NAME_STRING}~${to.toLowerCase()}~${from.toLowerCase()}`;
};

const getNextBarTime = (resolution, barTime) => {
  if (resolution?.includes("1D")) {
    // 1 day in minutes === 1440
    resolution = 1440;
  } else if (resolution?.includes("1W")) {
    // 1 week in minutes === 10080
    resolution = 10080;
  } else if (resolution?.includes("1M")) {
    // 1 month in minutes === 43800
    resolution = 43800;
  }
  const coeff = resolution * 60;
  return Math.floor(barTime / coeff) * coeff;
};

const subscribeBars = (
  symbolInfo,
  resolution,
  onRealtimeCallback,
  subscribeUID,
  onResetCacheNeededCallback,
  lastDailyBar,
  newKlineData
) => {
  const channelString = createChannelString(newKlineData.selectedPair);

  const handler = {
    id: subscribeUID,
    callback: onRealtimeCallback,
  };

  let subscriptionItem = channelToSubscription.get(channelString);

  if (subscriptionItem) {
    subscriptionItem.handlers.push(handler);
    onGetData(newKlineData);
    return;
  }

  subscriptionItem = {
    subscribeUID,
    resolution,
    lastDailyBar,
    handlers: [handler],
  };

  channelToSubscription.set(channelString, subscriptionItem);

  onGetData(newKlineData);
};

const onGetData = (_data) => {
  console.log('aserqwerqewrqewr', _data)
  const data = {
    sub_type: parseInt("0", 10),
    exchange: _data?.selectedPair,
    to: _data?.selectedPair?.split("_")[1]?.toUpperCase(),
    from: _data?.selectedPair?.split("_")[0]?.toUpperCase(),
    trade_id: _data.selectedPair,
    ts: _data?.time,
    volume: _data?.volume,
    price: _data?.close,
    close: _data?.close,
    open: _data?.open,
    high: _data?.high,
    low: _data?.low,
  };

  const tradePrice = _data?.price;
  const tradeTime = _data?.time;
  const tradeVolume = _data?.volume;

  const channelString = `0~${EXCHANGE_NAME_STRING}~${data?.to.toLowerCase()}~${data?.from.toLowerCase()}`;
  const subscriptionItem = channelToSubscription.get(channelString);

  if (subscriptionItem === undefined) {
    return;
  }

  const lastDailyBarData = subscriptionItem.lastDailyBar;

  const nextDailyBarTime = lastDailyBarData?.time / 10 ** 3;

  let bar;
  if (
    Object.keys(lastDailyBarData).length === 0 ||
    tradeTime > nextDailyBarTime
  ) {
    bar = {
      time: tradeTime * 10 ** 3,
      open: tradePrice,
      high: tradePrice,
      low: tradePrice,
      close: tradePrice,
      volume: tradeVolume,
    };
  } else {
    bar = {
      ...lastDailyBarData,
      high: Math.max(lastDailyBarData.high, tradePrice),
      low: Math.min(lastDailyBarData.low, tradePrice),
      close: tradePrice,
      volume: lastDailyBarData.volume + tradeVolume,
      time: nextDailyBarTime * 10 ** 3,
    };
  }

  subscriptionItem.lastDailyBar = bar;

  // send data to every subscriber of that symbol
  subscriptionItem.handlers.forEach((handler) => handler.callback(bar));
};

const unsubscribeBars = (subscriberUID) => {
  for (const channelString of channelToSubscription.keys()) {
    const subscriptionItem = channelToSubscription.get(channelString);
    const handlerIndex = subscriptionItem.handlers.findIndex(
      (handler) => handler.id === subscriberUID
    );

    if (handlerIndex !== -1) {
      // remove from handlers
      subscriptionItem.handlers.splice(handlerIndex, 1);

      if (subscriptionItem.handlers.length === 0) {
        // unsubscribe from the channel, if it was the last handler
        channelToSubscription.delete(channelString);
        break;
      }
    }
  }
};
